import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarServiceHistorySampleReport from "./component";
import { fetchSampleReportUrl } from "./actions";
import { fetchVhrCmsData } from "../../mobile/car-service-history-info/actions";

const mapStateToProps = (
    {
        carServiceHistoryInfo: {
            vhrCmsData
        }
    }
) => ({
    vhrCmsData
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchSampleReportUrlConnect: fetchSampleReportUrl,
            fetchVhrCmsDataConnect: fetchVhrCmsData
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CarServiceHistorySampleReport);
